// Точка входа. Стили импортируются раньше приложения: страница не мигает бесстилевым
// состоянием на медленном диске.

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@/app/globals.css';

import { App } from '@/app/App';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('в index.html нет элемента #root');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
